// removed by extract-text-webpack-plugin
module.exports = {"container":"SQKLGmziNV9zOYf5J5Ldz","barLeft":"_1ONukSXJmIrnUdC5XvYKif","iconTop":"jf1bbn5wwruwYy4i9oNCQ","textV":"_28kNrlZzYV-FMFiAfp7Lg0","actionIcon":"_3pQXZlvbbaWDk-66QR6D3b","content":"_13gy4c1tm5n1B_yfhL8qlr","date":"HLUa_jQQ122d2FXov5MWC","title":"k3Hk9JgoXWN0nbcL0rHAO","location":"_3sRD0QqUussn_2lgCcnc7O","city":"_3gzdzx05r7aVBEujBLtGr6","body":"_3zVyHTSRa3zkMO8-Kd2wSd","spam":"_3gAvA329O0PaxgpKdeh-Lf","item":"_2HVGZ9zidsja0azgfRfnNw","listMembers":"_1mNbBUcCR9MR8bsYHuF0NH"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/BoxInscription/add/style.css
// module id = 499
// module chunks = 38